// @flow

import React, { useState } from 'react'
import glamorous from 'glamorous'
import { uniq, find } from 'lodash'

import {
  HeadingText,
  TextInput,
  TextArea,
  Combobox,
} from '@paypalcorp/pp-react'

// content
import getContent from 'pp-react-l10n'
const l10n = getContent('pages/seller/details')

import HandleInput from './input-container'
import HandleMoreInfoLink from './handle-more-info-link'

const GenericInputContainerPadding = glamorous.div({
  margin: '26px 0',
})

const ButtonContainer = glamorous.div({
  display: 'flex',
})

const ContinueButton = glamorous.button({
  margin: '40px auto',
  width: '65%',
  '@media(max-width: 414px)': {
    margin: 'auto',
    width: '85%',
  },
})

function OnBoardingDetails(props) {
  const {
    merchantCategoryCodesList = [],
    sellerProfileState: {
      state: {
        businessName,
        businessHandle,
        businessDescription,
        businessCategory,
        businessCategoryLabel,
        isValidBusinessHandle,
      } = {},
    } = {},
  } = props

  // build the correct structure for category combobox
  const categoryOptions = merchantCategoryCodesList.map(item => {
    const terms = uniq(item.alternative_descriptions)
    return {
      label: item.title,
      value: `${item.id}`,
      id: `item-${item.id}`,
      _queryable: terms, // add mccTitle here! so we can just pull query and be done
    }
  })

  const [inputs, setInputs] = useState({
    businessName: businessName || '',
    businessHandle: businessHandle || '',
    businessDescription: businessDescription || '',
    businessCategory: businessCategory || '',
    businessCategoryLabel: businessCategoryLabel || '',
  })

  const handleChangeInput = e => {
    const isBusinessCategory = e.target.name === 'businessCategory'
    let label
    if (isBusinessCategory) {
      const categoryItem = find(
        merchantCategoryCodesList,
        item => {
          return `${item.id}` === e.target.value
        },
        {},
      )
      label = categoryItem.title
    }

    const updates = {
      ...inputs,
      [e.target.name]: e.target.value,
      ...(isBusinessCategory && {
        [`${e.target.name}Label`]: label,
      }),
    }
    setInputs(updates)
    props.sellerProfileState.updateBusinessDetails(updates)
  }

  const advanceToSocial = () => {
    props.history.push('/seller/social')
  }

  const revealNextCTA = () => {
    return (
      inputs.businessName !== '' &&
      inputs.businessHandle !== '' &&
      inputs.businessCategory !== '' &&
      inputs.businessDescription !== '' &&
      isValidBusinessHandle &&
      !errorTextArea
    )
  }

  // text area stuff
  const [value, setValue] = useState(businessDescription || '')
  const [isErrorTextArea, setErrorTextArea] = useState(false)
  const maxCharacters = 200
  const handleTextAreaChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    handleChangeInput(e)
    setValue(e.target.value)
    setErrorTextArea(e.target.value.length > maxCharacters)
  }
  const errorTextArea = isErrorTextArea && l10n('main.textArea.error')

  return (
    <>
      <HeadingText size="md" role="heading" aria-level="1">
        {l10n('main.heading')}
      </HeadingText>
      <br />
      <HandleMoreInfoLink />
      <GenericInputContainerPadding>
        <TextInput
          name="businessName"
          label={l10n('main.businessNameInput.label')}
          value={inputs.businessName}
          onChange={handleChangeInput}
          autoComplete="off"
        />
      </GenericInputContainerPadding>
      <GenericInputContainerPadding>
        <HandleInput
          sellerProfileState={props.sellerProfileState}
          inputValue={inputs.businessHandle}
          selectedValue={inputs.businessHandle}
          updateBusinessHandle={handleChangeInput}
        />
      </GenericInputContainerPadding>
      <GenericInputContainerPadding>
        <TextArea
          name="businessDescription"
          value={value}
          label={l10n('main.textArea.label')}
          onChange={handleTextAreaChange}
          showCharacterCounter
          maxCharacters={maxCharacters}
          errorText={errorTextArea}
          autoComplete="off"
        />
      </GenericInputContainerPadding>
      <GenericInputContainerPadding>
        <Combobox
          options={categoryOptions}
          name="businessCategory"
          label={l10n('main.category.label')}
          onChange={handleChangeInput}
          value={businessCategoryLabel || undefined}
        />
      </GenericInputContainerPadding>
      {revealNextCTA() && (
        <ButtonContainer>
          <ContinueButton
            className="vx_btn"
            label="Next"
            onClick={advanceToSocial}
          >
            {l10n('main.continue')}
          </ContinueButton>
        </ButtonContainer>
      )}
    </>
  )
}

export default OnBoardingDetails
